<p-select
  [options]="countryOptions"
  [(ngModel)]="selectedValue"
  (onChange)="onCountryChange($event)"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [styleClass]="styleClass"
  [filter]="true"
  filterPlaceholder="Search countries"
  [showClear]="!required"
  [class.p-invalid]="required && !selectedValue"
  optionLabel="label"
  optionValue="value"
  [appendTo]="appendTo"
/>
